// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"9079ae37","211":"85e33265","271":"c605a4e0","376":"c76dfa13","500":"edc113f9","828":"5e0824ee","879":"05219e08","969":"097d4196","973":"ef829639"}[chunkId] + ".chunk.js";
};